import AbstractView from "abstracts/AbstractView";
import Config from "configs/Config";


export default class Schedules extends AbstractView {

	constructor($wrapper) {
		super();
		this.$wrapper = $wrapper;
		this.init();
	}


	init() {
		const currentTime = new Date(),
			schedules = [{
				"open": "09:00",
				"close": "12:30"
			}, {
				"open": "14:00",
				"close": "17:30"
			}],
			offset = 2,
			openTxt = this.$wrapper.attr('data-open'),
			closeTxt = this.$wrapper.attr('data-close'),
			day = currentTime.getUTCDay(),
			hours = currentTime.getUTCHours(),
			minutes = currentTime.getUTCMinutes(),
			nowInMinutes = (hours + offset) * 60 + minutes,
			days = {
				'fr': ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'],
				'en': ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
			};
		// weekend = day 0 or 6
		// console.log( { schedules, offset, open, close, day, hours, minutes, nowInMinutes } );
		let isOpen = false;

		// Not weekend
		if (day !== 0 && day !== 6) {
			for (let index in schedules) {
				const schedule = schedules[index],
					open = schedule.open.split(':'),
					openHourInMinutes = parseInt(open[0]) * 60 + parseInt(open[1]),
					close = schedule.close.split(':'),
					closeHourInMinutes = parseInt(close[0]) * 60 + parseInt(close[1]);
				if (nowInMinutes > openHourInMinutes && nowInMinutes < closeHourInMinutes) {
					isOpen = true;
				}
			}
		}

		// OPEN
		if (isOpen) {
			this.$wrapper[0].innerHTML = '<span class="open">' + openTxt + '</span>';
			return;
		}

		// NOT OPEN
		let nextTimeOfDay = 0,
			nextScheduleIndex = 0,
			nextDay = days[Config.CURRENT_LANG][day],
			nextDayIndex = (day + 1) % 6;

		// Weekend
		if (day === 0 || day === 6) {
			nextScheduleIndex = 0;
			nextDayIndex = 1;
			nextDay = days[Config.CURRENT_LANG][nextDayIndex];
		} else {
			const openMorning = schedules[0].open.split(':'),
				openMorningHourInMinutes = parseInt(openMorning[0]) * 60 + parseInt(openMorning[1]),
				openAfternoon = schedules[1].open.split(':'),
				openAfternoonHourInMinutes = parseInt(openAfternoon[0]) * 60 + parseInt(openAfternoon[1]),
				closeMorning = schedules[0].close.split(':'),
				closeMorningHourInMinutes = parseInt(closeMorning[0]) * 60 + parseInt(closeMorning[1]),
				closeAfternoon = schedules[1].close.split(':'),
				closeAfternoonHourInMinutes = parseInt(closeAfternoon[0]) * 60 + parseInt(closeAfternoon[1]);
			if (nowInMinutes < openMorningHourInMinutes) {
				nextTimeOfDay = 0;
			} else if (nowInMinutes > closeMorningHourInMinutes && nowInMinutes < openAfternoonHourInMinutes) {
				nextTimeOfDay = 1;
			} else if (nowInMinutes > closeAfternoonHourInMinutes) {
				nextTimeOfDay = 2;
			}
			// nextTimeOfDay 0 = before
			// nextTimeOfDay 1 = midday
			// nextTimeOfDay 2 = evening
			nextScheduleIndex = nextTimeOfDay === 0 || nextTimeOfDay === 2 ? 0 : 1;
			if (nextTimeOfDay === 2) {
				nextDayIndex = (day + 1) % 6;
				while (nextDayIndex === 0 || nextDayIndex === 6) {
					nextDayIndex++;
				}
				nextDay = days[Config.CURRENT_LANG][nextDayIndex];
			}
		}
		if (Config.CURRENT_LANG === 'fr') {
			this.$wrapper[0].innerHTML = '<span class="close">' + closeTxt.replace('%h', schedules[nextScheduleIndex].open.replace(':', 'h')).replace('%d', nextDay) + '</span>';
		} else {
			this.$wrapper[0].innerHTML = '<span class="close">' + closeTxt.replace('%h', schedules[nextScheduleIndex].open).replace('%d', nextDay) + '</span>';

		}
	}
}
